import {
  Platform,
  ShopMulticitySummarySuccessResultEnum,
} from "@b2bportal/air-shopping-api";
import type {
  MulticityRoute,
  ShopMulticitySummaryRequest,
  ShopMulticitySummarySuccess,
} from "@b2bportal/air-shopping-api/lib/api";
import type { FlightState } from "@b2bportal/core-flights";
import type { ITripTerminus } from "@b2bportal/core-types";

import { flightsShoppingApi, getDeviceType } from "@overrides/utilities";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchMulticityFlights = createAsyncThunk<
  ShopMulticitySummarySuccess,
  void,
  { state: FlightState; rejectValue: { error: string } }
>("flightsShop/fetchMulticityFlights", async (_, thunkAPI) => {
  const state = thunkAPI.getState();
  const {
    passengerCounts: {
      adultsCount,
      infantsInSeatCount,
      infantsOnLapCount,
      childrenCount,
    },
    multicityRoutes,
    tripFilter,
  } = state.flights.flightSearch;
  const { isDesktopAndUp } = getDeviceType();
  try {
    if (multicityRoutes == null || multicityRoutes.length === 0) {
      return thunkAPI.rejectWithValue({ error: "Missing required fields" });
    }

    const routes = multicityRoutes
      .filter(
        (
          route
        ): route is {
          origin: ITripTerminus;
          destination: ITripTerminus;
          departureDate: string;
        } =>
          route.origin != null &&
          route.destination != null &&
          route.departureDate != null
      )
      .map(
        (route): MulticityRoute => ({
          origin: route.origin?.id.code,
          destination: route.destination?.id.code,
          departureDate: route.departureDate,
        })
      );

    const requestBody: ShopMulticitySummaryRequest = {
      passengers: {
        ADT: Number(adultsCount),
        ...(infantsInSeatCount ? { INS: Number(infantsInSeatCount) } : {}),
        ...(infantsOnLapCount ? { INF: Number(infantsOnLapCount) } : {}),
        ...(childrenCount ? { CNN: Number(childrenCount) } : {}),
      },
      routes,
      tripFilter,
      platform: isDesktopAndUp ? Platform.Desktop : Platform.Mobile,
      partnerParameters: {
        searchFixedPointsFares: false,
      },
    };

    const res =
      await flightsShoppingApi.apiV0ShopMulticitySummaryPost(requestBody);

    const data = res.data;

    switch (data.result.Result) {
      case ShopMulticitySummarySuccessResultEnum.Ok: {
        return data.result.value;
      }
      case ShopMulticitySummarySuccessResultEnum.Err: {
        return thunkAPI.rejectWithValue({ error: data.result.err.toString() });
      }
    }
  } catch (error) {
    // Reject the thunk with an error message
    return thunkAPI.rejectWithValue({ error: String(error) });
  }
});
